<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>Acknowledgments</b></div>
<div class="fmtx1">Earlier versions of these poems appeared in the following journals:</div>
<div class="fmtx"><div> <br/></div><div> <br/></div><i>751 Magazine</i> — “Maybe Motion Will Save Us All” and “Myth Left in Memory”</div>
<div class="fmtx"><i>A Public Space</i> — “Thought For a Stalled World”</div>
<div class="fmtx"><i>Barn Owl Review</i> — “For the Driftwood I Once Loved” and “Scientific Method”</div>
<div class="fmtx"><i>Bat City Review</i> — “[Seven years into the longest],” “[A shadow glimpsed inside],” and “[But a thought always hinges]”</div>
<div class="fmtx"><i>Boston Review</i> — “Goodbye to All That, the Birds Included”</div>
<div class="fmtx"><i>Cannibal</i> — “Poem in Place of a Fractured Sonnet”</div>
<div class="fmtx"><i>Court Green</i> — “Natural History”</div>
<div class="fmtx"><i>Diagram</i> — “In Light of Recent Developments”</div>
<div class="fmtx"><i>Gulf Coast</i> — “Sonnet”</div>
<div class="fmtx"><i>Horse Less Review</i> — “Slow Dancing Around What I Really Have to Say”</div>
<div class="fmtx"><i>La Fovea</i> — “Self-Portrait with House Slippers and Tap Water”</div>
<div class="fmtx"><i>The Laurel Review</i> — “Recalling an Earlier Snow During a Present Storm” and “Song”</div>
<div class="fmtx"><i>Mantis</i> — “Gathered” and “Harbor”</div>
<div class="fmtx"><i>New Orleans Review</i> — “Poem Beginning with a Line from Tranströmer”</div>
<div class="fmtx"><i>Ninth Letter</i> — “What Movement Sounds Like”</div>
<div class="fmtx"><i>Octopus Magazine</i> — “I’m Pretty Sure That’s a Hurdle in the Distance”</div>
<div class="fmtx"><i>Parthenon West Review</i> — “A Thought Before Thought”</div>
<div class="fmtx"><i>Phoebe</i> — “Reaching for a Lexicon, an Apple No Longer Shining”</div>
<div class="fmtx"><i>Strange New Egg</i> — “Fragment for an Avoided Disaster” and “Slow Dancing Around What I Really Have to Say”</div>
<div class="fmtx"><i>Sycamore Review</i> — “The Last Horse”</div>
<div class="fmtx"><i>The Tusculum Review</i> — “Light Bulb Hum” and “Vine”</div>
<div> <br/></div><div> <br/></div><div class="fmtx1">“As Complete as a Thought Can Be” appeared as a hand-sewn limited edition chapbook from Cannibal Books. Thank you to Katy and Matthew Henriksen.</div>
<div> <br/></div><div> <br/></div><div class="fmtx1">Thank you, also, to Alex Lemon, Wayne Miller, Michael Robins, Kate and Max Greenstreet, James Cihlar, Shannon Jonas, Zachary Schomburg, Matt Hart, Nancy Eimers, William Olsen, and Kimberley Clay.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adam_9781571318602_oeb_ack_r1.vue?a0b3fdd2